import React, { useEffect, useRef, useState } from 'react';
import { DataGrid, Box, DropDownBox, DateBox, SelectBox, Button } from 'devextreme-react';
import { Item } from "devextreme-react/box";
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Export,
    Scrolling,
    Selection,
    GroupPanel,
    SearchPanel,
    Grouping,
    Summary,
    TotalItem,
    GroupItem
} from 'devextreme-react/data-grid';

import { _path } from "../../../data/headerNavigation";
import { formatDate, resources } from '../../../data/app';
import { cellRender, cellRenderBold, dataFormatId, formatToMoneyNumber, onCellPreparedSales, } from '../../../utils/common';

import uri from '../../../utils/uri';
import useProducts from '../../../hooks/useProducts';
import http from '../../../utils/http';
import { dateByReport } from '../../../data/defaultObjects';
import { userService } from '../../../services/user.service';
import useAuthorization from '../../../hooks/useAuthorization';

const ResumenVentas = (props) => {

    const user = userService.getUser();

    const [areaId,] = useState(user.areaId);

    const [dateFrom, setDateFrom] = useState(dateByReport.from);
    const [dateTo, setDateTo] = useState(dateByReport.to);
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [_,] = useAuthorization(resources.verReporteDeVentas);
    //const [ options, setOptions ] = useState([]);

    let refData = useRef(null);


    const changeDateFrom = e => setDateFrom(e.value);

    const changeDateTo = e => setDateTo(e.value);

    const loadReport = () => {

        if (areaId > 0 && dateFrom && dateTo) {
            setLoading(true);
            http('reports/sales').asPost({ areaId, productId: null, from: dateFrom, to: dateTo, tipoFecha: 1, username: '' }).then(resp => {

                const data = resp;

                const groupedData = Object.values(
                    data.reduce((acc, curr) => {
                        const key = `${curr.id}|${curr.date}|${curr.fullName}|${curr.asignedTo}|${curr.total}|${curr.paymentTypeId}|${curr.paymentType}|${curr.payOfDate}`;

                        if (!acc[key]) {
                            acc[key] = {
                                id: curr.id,
                                date: curr.date,
                                fullName: curr.fullName,
                                asignedTo: curr.asignedTo,
                                total: curr.total,
                                totalNeto: curr.total,
                                paymentTypeId: curr.paymentTypeId,
                                paymentType: curr.paymentType,
                                payOfDate: curr.payOfDate,
                                payCash: curr.paymentTypeId === 1 ? curr.total : 0,
                                payCredit: curr.paymentTypeId === 2 ? curr.total : 0,
                                formaPagoEfectivo: curr.formaPagoEfectivo,
                                depositoTransferencia: curr.depositoTransferencia,
                                cheque: curr.cheque,
                                tarjeta: curr.tarjeta,
                                iva: 0,
                            };
                        }

                        return acc;
                    }, {})
                );                

                setData(groupedData);

                setLoading(false);
            });
        }

    };

    const toMoney = data => formatToMoneyNumber(data.value);

    const title = 'Reporte de Ventas';

    return (
        <div className="">

            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Desde:</label>
                        <DateBox type="date"
                            value={dateFrom}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateFrom} />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Hasta:</label>
                        <DateBox type="date"
                            value={dateTo}
                            displayFormat={formatDate}
                            openOnFieldClick={true}
                            onValueChanged={changeDateTo} />
                    </div>
                </Item>

                <Item ratio={4}>
                    <div style={{ paddingTop: '19px' }}>
                        <Button
                            width={120}
                            text={`${loading ? 'Buscando...' : 'Buscar'}`}
                            type="default"
                            icon="search"
                            stylingMode="contained"
                            className="m-1"
                            disabled={loading}
                            onClick={loadReport}
                        />
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <DataGrid
                        id="gridContainer"
                        ref={refData}
                        keyExpr="id"
                        selection={{ mode: 'single' }}
                        dataSource={data}
                        showBorders={true}
                        showRowLines={true}
                        hoverStateEnabled={true}
                        onCellPrepared={onCellPreparedSales}
                    >
                        <SearchPanel visible={true} width={200} />
                        <Grouping autoExpandAll={true} />
                        <Paging defaultPageSize={10} />
                        <Pager
                            showInfo={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 50, 100, 500]}
                        />
                        <Export enabled={true} fileName={title} allowExportSelectedData={true} />


                        <Column dataField="id" caption="Factura" width={70} cellRender={dataFormatId} />
                        <Column dataField="date" dataType="date" caption="Fecha" format={formatDate} width={100} />
                        <Column dataField="payOfDate"  dataType="date" caption="Fecha Pago" format={formatDate} width={100}/>      
                        <Column dataField="fullName" caption="Cliente" />
                        <Column dataField="asignedTo" caption="Vendedor" width={100} />
                        <Column dataField="payCredit" caption="Credito" cellRender={cellRender()} width={100} />
                        <Column dataField="payCash" caption="Contado" cellRender={cellRender()} width={100} />
                        <Column dataField="totalNeto" caption="Monto Neto" cellRender={cellRender()} width={100} />
                        <Column dataField="iva" caption="Impuesto" cellRender={cellRender()} width={100} />
                        <Column caption={'Totales'} alignment={'center'}>
                            <Column dataField="formaPagoEfectivo" caption="Monto Neto" cellRender={cellRender()} width={100} />                        
                            <Column dataField="depositoTransferencia" caption="Monto Neto" cellRender={cellRender()} width={100} />                        
                            <Column dataField="cheque" caption="Monto Neto" cellRender={cellRender()} width={100} />                        
                            <Column dataField="tarjeta" caption="Monto Neto" cellRender={cellRender()} width={100} />                        
                            <Column dataField="total" caption="Monto Neto" cellRender={cellRenderBold()} width={100} />                        
                        </Column>
                        <Summary>

                            <TotalItem column="asignedTo" summaryType="sum" customizeText={() => 'Totales :'} />
                            <TotalItem column="payCredit" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="payCash" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="costoTotal" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="totalNeto" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="iva" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="formaPagoEfectivo" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="depositoTransferencia" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="cheque" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="tarjeta" summaryType="sum" customizeText={toMoney} />
                            <TotalItem column="total" summaryType="sum" customizeText={toMoney} />
                        </Summary>
                    </DataGrid>
                </Item>
            </Box>
        </div>
    );
}



export default ResumenVentas;
